/* eslint-disable no-bitwise */
import country from "./estados_cidades.json";

export { default as taxTypeList } from "./tax-type-list";
export { default as especialTaxTypeList } from "./especial-tax-type-list";
export { default as toastUtils } from "./ToastUtils";
export { default as planStatusList } from "./plan-status-list";
export { default as addressTypeList } from "./address-type-list";
export { default as typeRequest } from "./type-request";
export { default as documentType } from "./document-type";

export function maskPhone(value: any): string {
  let valueLocal = value.replace(/\D/g, ""); // Remove tudo o que não é dígito

  valueLocal = valueLocal.replace(/^(\d\d)(\d)/, "($1) $2"); // Coloca parênteses em volta dos dois primeiros dígitos

  if (valueLocal.length < 14) {
    valueLocal = valueLocal.replace(/(\d{4})(\d)/, "$1-$2"); // Número com 8 dígitos. Formato: (99) 9999-9999
  } else {
    valueLocal = valueLocal.replace(/(\d{5})(\d)/, "$1-$2"); // Número com 9 dígitos. Formato: (99) 99999-9999
  }
  return valueLocal;
}

export function maskCEP(value: any): string {
  return value.replace(/\D/g, "").replace(/^(\d{5})(\d{3})+?$/, "$1-$2");
}

export const getState = (): any =>
  country.estados.map((el) => ({
    label: el.nome,
    value: el.sigla,
  }));
export const getCities = (stateSigla?: string): any => {
  if (!stateSigla) return [];
  return country?.estados
    ?.find((el) => el.sigla === stateSigla)
    ?.cidades?.map((el) => ({
      label: el,
      value: el,
    }));
};

export const stringToHash = (string: string): any => {
  let hash = 0;

  if (string.length === 0) return hash;

  // eslint-disable-next-line no-plusplus
  for (let i = 0; i < string.length; i++) {
    const char = string.charCodeAt(i);
    hash = (hash << 5) - hash + char;
    hash &= hash;
  }

  return hash;
};

/**
 * Cria um objeto Date a partir de uma string no formato ISO (YYYY-MM-DD)
 * sem problemas de fuso horário.
 * 
 * @param dateString - String no formato YYYY-MM-DD
 * @returns Date object no fuso horário local
 * 
 * @example
 * const date = parseDateWithoutTimezone("2025-11-07");
 * console.log(date.getDate()); // 7 (correto!)
 * console.log(date.toLocaleDateString()); // 07/11/2025 (correto!)
 */
export const parseDateWithoutTimezone = (dateString: string): Date => {
  const [year, month, day] = dateString.split("-").map(Number);
  return new Date(year, month - 1, day);
};
